/**
 * 指挥端 → App「坐标指令」文本约定（APP 可解析并一键复制）
 * 行首：【指挥坐标】纬度,经度
 */

export const LOCATION_CMD_PREFIX = '【指挥坐标】';

/** @returns {string} */
export function formatLocationCommandText(lat, lng, note = '') {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return '';
  const head = `${LOCATION_CMD_PREFIX}${la.toFixed(6)},${ln.toFixed(6)}`;
  const extra = String(note || '').trim();
  return extra ? `${head}\n${extra}` : head;
}

/**
 * 从指令正文解析坐标
 * @returns {{ lat: number, lng: number, copyText: string } | null}
 */
export function parseLocationCommandText(text) {
  const raw = String(text || '').trim();
  if (!raw) return null;
  const m = raw.match(/【指挥坐标】\s*(-?\d+(?:\.\d+)?)\s*[,，]\s*(-?\d+(?:\.\d+)?)/);
  if (!m) {
    const m2 = raw.match(/^(-?\d+(?:\.\d+)?)\s*[,，]\s*(-?\d+(?:\.\d+)?)\s*$/);
    if (!m2) return null;
    const lat = Number(m2[1]);
    const lng = Number(m2[2]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
    return { lat, lng, copyText: `${lat.toFixed(6)},${lng.toFixed(6)}` };
  }
  const lat = Number(m[1]);
  const lng = Number(m[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { lat, lng, copyText: `${lat.toFixed(6)},${lng.toFixed(6)}` };
}

/**
 * 指挥对话勾选「携带位置」时解析坐标：
 * 正文里已有【指挥坐标】优先，否则用队员最新上报位置
 * @returns {{ lat: number, lng: number, source: 'text' | 'member' } | null}
 */
export function resolveCommandAttachCoords(member, text) {
  const fromText = parseLocationCommandText(text);
  if (fromText) {
    return { lat: fromText.lat, lng: fromText.lng, source: 'text' };
  }
  const lat = Number(member?.last_latitude ?? member?.latitude ?? member?.lat);
  const lng = Number(member?.last_longitude ?? member?.longitude ?? member?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { lat, lng, source: 'member' };
}
